/**
 * @module Landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { HomeComponent } from '@experience/landing/common/components/home/home.component';
import { CONTENT_ENDPOINT } from '@core/aem/content-endpoints';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { ActivatedRoute } from '@angular/router';
import { PdlWrapperService } from '@core/services/pdl-wrapper.service';

@Component({
  selector: 'tmo-web-home',
  templateUrl: './web-home.component.html',
  styleUrls: ['./web-home.component.scss'],
})
export class WebHomeComponent extends HomeComponent implements OnInit, OnDestroy {
  public aemId: string = '';

  constructor(
    public pdlService: PdlService,
    public route: ActivatedRoute,
    private pdlWrapperService: PdlWrapperService
  ) {
    super(pdlService, route);
  }

  public ngOnInit(): void {
    if (!this.pdlWrapperService.isPdlDepsLoaded) {
      this.pdlWrapperService.pdlSetCaptureEventObservable.asObservable().subscribe(() => {
        this.pdlWrapperService.isPdlDepsLoaded = true;
        super.ngOnInit();
      });
    } else {
      super.ngOnInit();
    }
    this.aemId = CONTENT_ENDPOINT.WEB_HOME;
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
